import React, { Component, useEffect, useState } from 'react';
import { pageDetails } from '../Recoil/ActiveEvents';
import { useRecoilValue } from 'recoil';
import NewImageGallery from './newImageGallery.jsx';


const ImageGallery = () => {
  const [selectedTab, setSelectedTab] = useState('tab1');
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const selectedEvent = useRecoilValue(pageDetails);

  useEffect(() => {
    let eventURI = process.env.REACT_APP_API_URL +"/Gallary/GetEventGallary";
    fetch(eventURI ,  {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body:  JSON.stringify({"ImageId":"","EventId": !!selectedEvent.selectedEID ? selectedEvent.selectedEID :'' }),
      redirect: "follow"
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((result) =>{
      let evtResult = !!result && !!result.EventGallary ? result.EventGallary : [];
      let images = !!evtResult && evtResult.length > 0? evtResult.filter((obj)=> obj.FileType == 'image') : [];
      let videos = !!evtResult && evtResult.length > 0? evtResult.filter((obj)=> obj.FileType == 'video') : [];
      setImages(images)
      setVideos(videos);
      setSelectedTab('tab2');
      setTimeout(() => {
        
        setSelectedTab('tab1')
      }, 100);
    }
    )
    .catch((error) => console.error(error));
  }, []);

  // Function to open the modal and set the current image
  const openModal = (index) => {
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Function to navigate to the previous image in the modal
  const previousImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Function to navigate to the next image in the modal
  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };
    return (
      <div className='pt-10'>
        <div className='max-w-[90vw] mx-auto px-4'>
          <h1 className='text-headerTitle text-h-1 font-bold'>Gallery</h1>
          <div>
              <div className="flex justify-center items-center">
              <button
                onClick={() => setSelectedTab('tab1')}
                // className='bg-sandle-light'
                className={`rounded-l-[25px] border-2 border-yellow-bg border-r-0 py-3 px-7  ${selectedTab === 'tab1' ? 'bg-yellow-bg font-semibold' : 'bg-sandle-light'}`}
              >
                Images
              </button>
              <button
                onClick={() => setSelectedTab('tab2')}
                className={`rounded-r-[25px] border-2 border-yellow-bg border-l-0 py-3 px-7 ${selectedTab === 'tab2' ? 'bg-yellow-bg font-semibold' : 'bg-sandle-light'}`}
              >
                Videos
              </button>
            </div>

            {/* Tab content */}
            <div className="p-4">
              {selectedTab === 'tab1' && (
                <div>
                    {/* Thumbnails */}
                    <div >
                    {images.length === 0 ? (
                      <p className='text-center mt-4 text-lg'>Event images is currently unavailable.</p>
                    ) : (
                      <div className="relative w-full max-w-[90vw] mx-auto mt-10">
                        {/* <Gallery images={images}/> */}
                        <NewImageGallery img={images} />
                      </div>
                    )}
                  </div>
                </div>
              )}
              {selectedTab === 'tab2' && (
                  <div>
                  {videos.length === 0 ? (
                      <p className='text-center mt-4 text-lg'>Event video is currently unavailable.</p>
                    ) : (
                      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 gap-4">
                        {videos.map((obj, index) => (
                          <div
                            key={index}
                            className="cursor-pointer border rounded overflow-hidden shadow-md"
                            onClick={() => openModal(index)}
                          >
                            <img
                              src= {"https://kalingarayanrunners.com/assets/images/"+(index+1)+".jpg"}//{obj.ImageURL}
                              // onerror="this.onerror=null; this.src='https://ionicframework.com/docs/img/demos/thumbnail.svg';"
                              alt={`Thumbnail ${index + 1}`}
                              className="w-full h-56 object-cover"
                            />
                          </div>
                        ))}
                        </div>
                    )}
                    
                      {/* Modal */}
                    {isModalOpen && (
                      <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                        <div className="relative bg-white p-4 rounded shadow-lg">
                          <button
                            className="absolute top-2 right-2 text-gray-700"
                            onClick={closeModal}
                          >
                            &times;
                          </button>
                          <div className="flex items-center justify-between">
                            <button
                              className="bg-gray-200 p-2 px-3 rounded shadow hover:bg-gray-300"
                              onClick={previousImage}
                            >
                              &lt;
                            </button>
                            {/* <img
                              src={images[currentIndex].ImageURL}
                              alt={`Main Image ${currentIndex + 1}`}
                              className="max-w-[50vw]"
                            /> */}
                             <video className='max-h-[80vh]' width="640" height="360" controls >
                              <source src={videos[currentIndex].ImageURL} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                            <button
                              className="bg-gray-200 p-2 px-3 rounded shadow hover:bg-gray-300"
                              onClick={nextImage}
                            >
                              &gt;
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
        
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }

export default ImageGallery;
